import { onError } from '@apollo/client/link/error'

import { sendLogFromApolloLink } from '../../logger/btimeLogs/logFromApolloLink'

export const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (networkError) {
    console.log(`[Network error]: ${networkError}`)
    sendLogFromApolloLink(operation, { errors: networkError?.toString() })
  }
})
